import { render, staticRenderFns } from "./PaymentBatchList.vue?vue&type=template&id=4d62ed97&scoped=true"
import script from "./PaymentBatchList.vue?vue&type=script&lang=js"
export * from "./PaymentBatchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d62ed97",
  null
  
)

export default component.exports